import { Modal, PrimaryButton, SecondaryButton, Typography } from '@weareopenr/component-library';
import { useForm } from 'react-hook-form';
import VenueChannelsFields from 'src/components/VenueChannelsFields';
import { useUpdateVenueChannels } from 'src/hooks/useUpdateVenueChannels';
import { createChannelsInitialValues, isChannelsDataChanged } from './utilities';
import { IFormValues } from './types';
import { IVenue } from 'src/types/venue.types';
import { IAggregator } from 'src/types/aggregator.types';
import { IVenueCreateFormValues } from 'src/components/VenueCreateForm/types';
import styles from './VenueChannelsEditModal.module.scss';

interface IVenueChannelsEditForm {
  venue: IVenue;
  aggregators: IAggregator[];
  onModalClose: () => void;
}

interface IVenueChannelsEditModal extends IVenueChannelsEditForm {
  isModalOpen: boolean;
}

const VenueChannelsEditForm = ({ venue, aggregators, onModalClose }: IVenueChannelsEditForm) => {
  const { mutate: updateVenueChannels, isLoading } = useUpdateVenueChannels(venue, onModalClose);

  const formFields = useForm<IFormValues | IVenueCreateFormValues>({
    defaultValues: {
      channels: createChannelsInitialValues(venue, aggregators),
    },
    mode: 'onChange',
  });

  const {
    handleSubmit,
    register,
    formState: { errors, dirtyFields, isSubmitting },
  } = formFields;

  const onSubmit = async (data: IFormValues) => {
    if (!isChannelsDataChanged(dirtyFields.channels)) return onModalClose();

    updateVenueChannels({
      id: venue.venueId,
      body: data,
    });
  };

  return (
    <form
      className={styles['venue-channels-form']}
      onSubmit={handleSubmit(onSubmit)}
      id="venue-channels-form"
      aria-label="venue-channels-form"
    >
      <Typography size="xxlarge" weight="semi-bold" className={styles['heading-text']}>
        Edit channels for {venue.name}
      </Typography>
      <VenueChannelsFields aggregators={aggregators} register={register} errors={errors} />
      <div className={styles['buttons-container']}>
        <SecondaryButton type="button" size="full-width" buttonStyle="outline" onClick={onModalClose}>
          Back
        </SecondaryButton>
        <PrimaryButton loading={isSubmitting || isLoading} size="full-width" type="submit">
          Save
        </PrimaryButton>
      </div>
    </form>
  );
};

const VenueChannelsEditModal = ({ isModalOpen, onModalClose, venue, aggregators }: IVenueChannelsEditModal) => {
  return (
    <Modal open={isModalOpen} closeModal={onModalClose}>
      <VenueChannelsEditForm venue={venue} aggregators={aggregators} onModalClose={onModalClose} />
    </Modal>
  );
};

export default VenueChannelsEditModal;
